import axios from './axios';
import config from '../../helpers/config';

export default (designId, identityId, email) => {
  const url = config.designBuilderLinkToMyAccountPath.replace('<guid>', designId);

  return axios.post(
    url,
    { designId, identityId, email },
  );
};
